import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiShield } from 'react-icons/fi';

export default function Layout() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const location = useLocation();

  // Close menu on route change
  React.useEffect(() => {
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Executive Header */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/shadow-ai-benchmark-report-2026" className="flex items-center gap-2 group">
              <div className="bg-slate-900 p-1.5 rounded-md group-hover:bg-peridot-600 transition-colors">
                <FiShield className="text-white" size={20} />
              </div>
              <span className="font-bold text-xl tracking-tight text-slate-900">Peridot</span>
              <span className="hidden sm:inline text-slate-400 font-light mx-2">|</span>
              <span className="hidden sm:inline text-sm font-medium text-slate-600">Research</span>
            </Link>
            
            <div className="hidden md:flex items-center gap-6">
              <Link to="/shadow-ai-benchmark-report-2026" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
                Report Home
              </Link>
              <Link to="/ai-governance-audit" className="bg-slate-900 hover:bg-slate-800 text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition-all shadow-sm">
                Request Audit
              </Link>
            </div>

            <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 z-40 bg-white border-b border-slate-200 p-4">
          <nav className="flex flex-col gap-4">
             <Link to="/shadow-ai-benchmark-report-2026" className="text-lg font-medium text-slate-900 p-2">
                Report Home
              </Link>
              <Link to="/ai-governance-audit" className="bg-slate-900 text-center text-white px-5 py-3 rounded-lg text-lg font-semibold mt-4">
                Request Audit
              </Link>
          </nav>
        </div>
      )}

      {/* Main Content */}
      <main className="flex-grow pb-24 md:pb-0">
        <Outlet />
      </main>

      {/* Mobile Sticky CTA */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-slate-200 z-50">
        <Link to="/ai-governance-audit" className="flex items-center justify-center w-full bg-peridot-500 text-slate-950 px-5 py-3.5 rounded-lg font-bold shadow-lg">
          Request AI Audit
        </Link>
      </div>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 py-12 pb-32 md:pb-12 border-t border-slate-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2">
            <FiShield size={24} className="text-slate-700" />
            <span className="font-semibold text-slate-300">Peridot AI Governance Research</span>
          </div>
          <p className="text-sm">© 2026 Peridot. Data based on n=400 enterprise survey.</p>
        </div>
      </footer>
    </div>
  );
}